function parseRecords(response) {
  if (!response)
    return null;
  const { richText, MainContent: [{ firstRecNum, lastRecNum, recsPerPage, totalNumRecs, records }], } = response.contents[0];
  return {
    richText: (richText === null || richText === void 0 ? void 0 : richText.map((text) => text.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim())) || [],
    products: records
      ? {
        firstRecNum,
        lastRecNum,
        recsPerPage,
        totalNumRecs,
        records: records.map(({ attributes }) => ({
          description: attributes['product.description'][0],
          price: attributes['product.price'][0],
          currency: attributes['product.currency'][0],
          repositoryId: attributes['product.repositoryId'][0],
          pictureUrl: attributes['product.pictureUrl'][0],
        })),
      }
      : null,
  };
}
const tryParse = (data) => {
  try {
    return JSON.parse(data);
  }
  catch (e) {
    console.warn('tryParse ', e);
    return data;
  }
};
const tryStringify = (data) => {
  try {
    return JSON.stringify(data);
  }
  catch (e) {
    console.warn('tryStringify ', e);
    return data;
  }
};

export { tryStringify as a, parseRecords as p, tryParse as t };
